var createPhoneNumberLink = function (phoneNumber) {
    return "<a href=\"tel:".concat(phoneNumber, "\" style=\"white-space: nowrap;\">").concat(phoneNumber, "</a>");
};
var createPhoneNumberBoldLink = function (phoneNumber) {
    return "<b>".concat(createPhoneNumberLink(phoneNumber), "</b>");
};
var createPhoneNumberBoldText = function (phoneNumber) {
    return "<b>".concat(phoneNumber, "</b>");
};
var createPhoneNumber = function (phoneNumber) {
    return {
        text: phoneNumber,
        boldText: createPhoneNumberBoldText(phoneNumber),
        link: createPhoneNumberLink(phoneNumber),
        boldLink: createPhoneNumberBoldLink(phoneNumber),
    };
};
var DP_SUPPORT_PHONE_NUMBER_RAW = "833-265-4540";
export var DP_SUPPORT_PHONE_NUMBER = createPhoneNumber(DP_SUPPORT_PHONE_NUMBER_RAW);
var GENERAL_SUPPORT_PHONE_NUMBER_RAW = "844-422-6922";
export var GENERAL_SUPPORT_PHONE_NUMBER = createPhoneNumber(GENERAL_SUPPORT_PHONE_NUMBER_RAW);
//# sourceMappingURL=contactInfo.js.map